/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {convertSvgToDataUri} from '@ion/core/src/utils/Encoding';
import {dlsColor} from '@ion/dls/src/theme/theme';

export interface StopEventOffsetEUMarker {
  size?: number,
  borderColor?: string,
  fillColor?: string
};

/**
 * Utility function that returns an image from SVG that can be passed
 * to the esri Graphic constructor to make a graphic with Offset for stop events of the asset
 *
 * ```typescript
 *  import {getStopEventOffsetEUMarker} from '@ion/dls/src/maps/markers';
 *
 *  return {
 *    type   : 'picture-marker',
 *    url    : getStopEventOffsetUSMarker({size, fillColor}),
 *    width  : size,
 *    height : size,
 *    angle  : 0
 * }
 * ```
 */
export const getStopEventOffsetEUMarker = ({
  fillColor = dlsColor('caOrange'),
  borderColor = dlsColor('white'),
  size = 48
}: StopEventOffsetEUMarker) => {
  const svg = (`
    <svg width="${size}" height="${size}" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="12" width="24" height="24" rx="12" fill="${borderColor}"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12 34C17.5228 34 22 29.5228 22 24C22 18.4772 17.5228 14 12 14C6.47715 14 2 18.4772 2 24C2.00619 29.5203 6.47972 33.9938 12 34Z" fill="${fillColor}"/>
      <path d="M15.4629 19.2298C15.8239 18.8693 16.4086 18.8692 16.7695 19.2298C17.1304 19.5909 17.1305 20.1764 16.7695 20.5374L13.3066 23.9994L16.7695 27.4622C17.1305 27.8232 17.1312 28.4088 16.7705 28.7699C16.4095 29.1309 15.824 29.1307 15.4629 28.7699L11.999 25.307L8.53711 28.7699C8.17609 29.1309 7.59057 29.1308 7.22949 28.7699C6.86872 28.4088 6.86852 27.8232 7.22949 27.4622L10.6914 23.9994L7.22949 20.5374C6.86873 20.1765 6.8689 19.5909 7.22949 19.2298C7.59053 18.8691 8.17613 18.869 8.53711 19.2298L11.999 22.6917L15.4629 19.2298ZM7.63379 28.6898C7.63661 28.691 7.63974 28.6915 7.64258 28.6927C7.60687 28.6778 7.57206 28.6599 7.53906 28.638L7.63379 28.6898ZM16.3574 28.6917C16.3928 28.677 16.4273 28.6596 16.46 28.638L16.4609 28.6361C16.4278 28.6579 16.3933 28.6767 16.3574 28.6917ZM15.7598 28.6292C15.7615 28.6305 15.7638 28.631 15.7656 28.6322C15.7338 28.6105 15.703 28.5862 15.6748 28.558L15.7598 28.6292ZM16.5576 28.558C16.5383 28.5773 16.5162 28.5926 16.4951 28.6087L16.5586 28.558C16.589 28.5275 16.6159 28.4949 16.6387 28.4603C16.6158 28.495 16.5882 28.5274 16.5576 28.558ZM16.5576 20.3246L13.0947 23.7874L16.5576 20.3255C16.5882 20.2949 16.6148 20.2617 16.6377 20.2269L16.5576 20.3246Z" fill="${borderColor}"/>
    </svg>
  `);
  return convertSvgToDataUri(svg.trim());
};

export default getStopEventOffsetEUMarker;
